import Vue from 'vue';
import ElementUI from 'element-ui';
import DataTables from 'vue-data-tables';
import VueQuillEditor from 'vue-quill-editor';
//import Stripe from 'stripe';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

import store from './store'

// require styles
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import 'element-ui/lib/theme-chalk/index.css';

window._ = require('lodash');

//FullStory
window.FS = FS;
//Import and Expose Parse Globally.
import Parse from 'parse';
window.Parse = Parse;
//var url = window.location.href;

var config = {
	parseAppId: "jiVdRC4xC50dPvikZlZdKvuhROmcmNRRkPhhWQXq",
	parseJSKey:  "S63aQvGGPpHyMLPlGfDo0vl9NRchROXSkhcPnSaM",
	parseServer: 'https://pg-app-vow9a1l9cqmphc0xygu0pyatzi95vu.scalabl.cloud/1/',
	stripeKey: 'pk_live_s5PuU0RrWU69eMOf5b0tT8vb'
};
// if(url.indexOf('thewodapalooza') <0 && url.indexOf('myftpupload') <0){
// 	console.log("USING DEV")
// 	//Override Config for Dev
// 	config = {
// 		parseAppId: "w7iEcpTfKx1tFNpGDs0CPd1XafXzTPEckPp9mRjq",
// 		parseJSKey:  "bbue2KLmTqLepYjUKJ0RPZ4GpzERkTjqSPenaP6n",
// 		parseServer: 'https://pg-app-48ptgz27pxwxu4dqxrygvqiwyijxtq.scalabl.cloud/1/',
// 		stripeKey: 'pk_test_CKWpVCGgOZyDiJEN01r5DWBc'
// 	};
// }
Parse.initialize(
  config.parseAppId,
  config.parseJSKey
);
Parse.serverURL = config.parseServer;

var stripe = Stripe(config.stripeKey);
//var stripe = Stripe('pk_test_CKWpVCGgOZyDiJEN01r5DWBc');
window.stripe = stripe;
import VueRouter from 'vue-router';

Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(DataTables);
Vue.use(VueQuillEditor);
locale.use(lang);

import App from './App';
import Signup from './components/signup';
import SignupPlan from './components/signup/plan';
import SignupCheckout from './components/signup/checkout';
import SignupConfirmation from './components/signup/confirmation';
import Login from './components/login';
import ForgotPassword from './components/forgot-password';
import ResetPassword from './components/forgot-password/reset';
import Dashboard from './components/dashboard';
//import DashboardHome from './components/dashboard/home';
import DashboardHomePre from './components/dashboard/home/prestage';
//import DashboardStart from './components/dashboard/start';
import DashboardContent from './components/dashboard/content';
import DashboardContentArticle from './components/dashboard/content/article';
import DashboardProgress from './components/dashboard/progress';
import DashboardSettings from './components/dashboard/settings';
import DashboardMyDetails from './components/dashboard/settings/mydetails.vue';
import DashboardAddons from './components/dashboard/addons';

import Terms from './components/dashboard/content/terms';


import Admin from './components/admin/';
import AdminUsers from './components/admin/users';
import AdminVoting from './components/admin/voting';
import AdminContent from './components/admin/content';
import AdminContentForm from './components/admin/content/form';
import AdminPromoCodes from './components/admin/promocodes';
import AdminSponsors from './components/admin/sponsors';
import AdminPrograms from './components/admin/programs';
import AdminEquipment from './components/admin/equipment';
import ImportUsers from './components/admin/users/import';


const routes = [

  { path: '/', component: Login },
  { path: '/signup', component: Signup },
  { path: '/signup/plan', component: SignupPlan },
  { path: '/signup/checkout', component: SignupCheckout },
  { path: '/signup/confirmation', component: SignupConfirmation},
  { path: '/login', component: Login },
  { path: '/forgot-password', component: ForgotPassword },
  { path: '/reset-password/', component: ResetPassword },
  { path: '/dashboard', component: Dashboard,
	children:[{
		path:'/',
		component:DashboardHomePre
	},{
		path:'prestage',
		component:DashboardHomePre
	},
	// {
	// 	path:'start',
	// 	component:DashboardStart
	// },
	{
		path:'content',
		component:DashboardContent
	},{
		path:'content/article/',
		component:DashboardContentArticle
	},{
		path:'content/article/:id',
		component:DashboardContentArticle
	},{
		path:'progress',
		component:DashboardProgress
	},{
		path:'settings',
		component:DashboardSettings,
	},{
		path: 'my-details',
		component:DashboardMyDetails,
	},{
		path:'addons',
		component:DashboardAddons
	},{
		path: 'terms',
		component: Terms
	}]
  },{ path: '/admin-panel', component: Admin,
	children:[{
		path:'/',
		component:AdminUsers
	},{
		path:'users',
		component:AdminUsers
	},{
		path:'import-users',
		component:ImportUsers
	},{
		path:'voting',
		component:AdminVoting
	},{
		path:'content',
		component:AdminContent
	},{
		path:'content/form',
		component:AdminContentForm
	},{
		path:'content/form/:id',
		component:AdminContentForm
	},{
		path:'promocodes/',
		component:AdminPromoCodes
	},{
		path:'sponsors/',
		component:AdminSponsors
	},{
		path:'programs/',
		component:AdminPrograms
	},{
		path:'equipment/',
		component:AdminEquipment
	}]
  }
];

const router = new VueRouter({
  routes, // short for `routes: routes`
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
  }
});

new Vue({
   router,
   store,
   render: h => h(App),
}).$mount('#app');

// new Vue({
//   el: '#app',
//   render: h => h(App)
// });
